module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column p-3 justify-content-between bootstrap-gde-height"
  }, [_c('div', {
    staticClass: "d-grid"
  }, [_c('FormSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.includes('region_id')),
      expression: "fields.includes('region_id')"
    }],
    staticClass: "mb-3",
    attrs: {
      "label": "Регион",
      "name": "region_id",
      "placeholder": "Выберите регион",
      "required": true,
      "v": _vm.$v.region_id,
      "bold": false,
      "large": true,
      "wide": true,
      "options": _vm.regionsDict,
      "filterable": true,
      "error-text": _vm.$util.validationMessage(_vm.$v.region_id)
    },
    model: {
      value: (_vm.region_id),
      callback: function($$v) {
        _vm.region_id = $$v
      },
      expression: "region_id"
    }
  }), _c('FormSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.includes('municipality_id')),
      expression: "fields.includes('municipality_id')"
    }],
    staticClass: "mb-3",
    attrs: {
      "label": "Муниципалитет",
      "name": "municipality_id",
      "placeholder": "Выберите Муниципалитет",
      "type": "text",
      "disabled": _vm.isDisableMunicipality,
      "required": true,
      "v": _vm.$v.municipality_id,
      "large": true,
      "options": _vm.municipalitetDict,
      "error-text": _vm.$util.validationMessage(_vm.$v.municipality_id)
    },
    model: {
      value: (_vm.municipality_id),
      callback: function($$v) {
        _vm.municipality_id = $$v
      },
      expression: "municipality_id"
    }
  }), _c('FormSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.includes('sex')),
      expression: "fields.includes('sex')"
    }],
    staticClass: "mb-3",
    attrs: {
      "label": "Пол",
      "name": "sex",
      "placeholder": "Выберите пол",
      "required": true,
      "v": _vm.$v.sex,
      "large": true,
      "options": _vm.genderOptions,
      "error-text": _vm.$util.validationMessage(_vm.$v.sex)
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }), _c('FormSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.includes('edu_level_id')),
      expression: "fields.includes('edu_level_id')"
    }],
    staticClass: "mb-3",
    attrs: {
      "label": "Образование",
      "name": "edu_level_id",
      "placeholder": "Выберите уровень образования",
      "required": true,
      "v": _vm.$v.edu_level_id,
      "large": true,
      "options": _vm.levelOptions,
      "error-text": _vm.$util.validationMessage(_vm.$v.edu_level_id)
    },
    model: {
      value: (_vm.edu_level_id),
      callback: function($$v) {
        _vm.edu_level_id = $$v
      },
      expression: "edu_level_id"
    }
  }), _c('FormInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.includes('snils')),
      expression: "fields.includes('snils')"
    }],
    staticClass: "mb-3",
    attrs: {
      "placeholder": "Введите СНИЛС",
      "label": "Введите СНИЛС (для вашей идентификации)",
      "name": "snils",
      "mask": _vm.snilsMask,
      "error-text": _vm.$util.validationMessage(_vm.$v.snils),
      "v": _vm.$v.snils
    },
    model: {
      value: (_vm.snils),
      callback: function($$v) {
        _vm.snils = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "snils"
    }
  }), _c('FormInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.includes('birthday')),
      expression: "fields.includes('birthday')"
    }],
    staticClass: "mb-3",
    attrs: {
      "placeholder": "Введите дату рождения",
      "label": "Дата рождения",
      "name": "birthday",
      "mask": _vm.dateMask,
      "error-text": _vm.$util.validationMessage(_vm.$v.birthday),
      "required": true,
      "v": _vm.$v.birthday
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "birthday"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end pb-3"
  }, [_c('AppButtonNew', {
    attrs: {
      "disabled": _vm.$v.$invalid,
      "call-back-fn": _vm.sendAdditionalUserData
    }
  }, [_vm._v("Далее")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52db45ae","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue
// module id = 0f9a7b2bea2da428224d
// module chunks = 0